//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiInformationOutline } from '@mdi/js'
import { computed, useSlots } from '@vue/composition-api'
import { formatCurrency } from '@core/utils'

export default {
  name: 'ActionCard',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    feeTaxes: {
      type: Number,
      default: 0,
    },
    facilityName: {
      type: String,
      default: '',
    },
    fieldName: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    includeVideo: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const slots = useSlots()

    const hasIconContent = computed(() => !!slots.icon)

    return {
      hasIconContent,

      formatCurrency,

      icons: {
        mdiInformationOutline,
      },
    }
  },
}
